<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les Animateurs" />
            <LesAnimateurs />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesAnimateurs from './LesAnimateurs.vue'


export default {
    name: 'AnimateursPage',
    components: {
        NavBar,
        PageTitle,
        LesAnimateurs,
        FooterComp,
    }
}
</script>